<template>
  <div class="is-marginless is-paddingless" v-if="liensInferieurs">
    <div class="columns">
      <div class="column is-12">
        <div class="card">
          <header class="header-card">
            <p>
              {{ $t('detailClient.generalTitle.organisation')}}
            </p>
          </header>
          <div class="card-content has-background-background has-text-centered"
               v-if="liensInferieurs.tiersEnfants.length === 0">
            <h1 class="title is-size-4" v-if="tiersInformation.typologie === groupe">
              {{ $t('detailClient.organisation.aucunlienGroupe',
              { client: tiersInformation.nomCommercial })}}</h1>
            <h1 class="title is-size-4" v-else>{{ $t('detailClient.organisation.aucunlienEnseigne',
              { client: tiersInformation.nomCommercial })}}</h1>
          </div>
          <div class="card-content" v-else>
            <div class="mgt-10px VueTables">
              <div class="table-responsive">
                <div class="level mgt-20px">
                  <div class="level-left"></div>
                  <div class="level-right">
                    <div class="mgr-2 is-narrow">
                      <qd-button v-if="moduleStockActive"
                                class="is-addOrEdit"
                                @click='transfertModale = !transfertModale'>
                        <span class="is-size-7">
                          {{$t('detailClient.organisation.transfertDeStock')}}
                        </span>
                      </qd-button>
                    </div>
                    <div class="mgr-2 is-narrow">
                      <exportExcelButton
                        :perm="permClientsContacts.exporter"
                        :query="exportExcelQuery"/>
                    </div>
                    <div class="is-narrow">
                      <parametrage-table
                        :reference-table="referenceTable"
                        @endLoadParamtre="startArrayRendering = true">
                      </parametrage-table>
                    </div>
                  </div>
                </div>
                <v-client-table :data="liensInferieurs.tiersEnfants"
                                :columns="columns"
                                :options="options"
                                :ref="referenceTable"
                                @sorted="onSorted">
                  <template slot='afterTable'>
                    <table-items-in-view
                      :perPage="resultPerPage"
                      @input="$refs[referenceTable].setLimit($event)"
                    />
                  </template>
                  <template slot='appendBody' v-if="moduleStockActive">
                    <table-footer-totaux
                      ref="tableTotaux"
                      :columns="columns"
                      :target="targetTotal"
                      :items="this.liensInferieurs.tiersEnfants"
                      :formatage="(value) => value">
                    </table-footer-totaux>
                  </template>
                  <template slot="nomCommercial" slot-scope="props">
                    <router-link-blank :to="{ name: 'c.bodac.clients/contacts-client',
                    params: {id: props.row.id}}"
                                       :message="props.row.nomCommercial">
                    </router-link-blank>
                  </template>
                  <template slot="soldeStock" slot-scope="props">
                    <div class="is-pulled-right">
                      {{props.row.soldeStock}}
                    </div>
                  </template>
                </v-client-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="transfertModale"
             has-modal-card>
      <pop-up-transfer-stock  @close="closePopup()"
                              :listLieuxDeStockage="liensInferieurs.tiersEnfants"
                              :tiersInformation="tiersInformation">
      </pop-up-transfer-stock>
    </b-modal>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import { getWithLiensInferieurs } from '@/api/tiers/index';
import messageErreur from '@/services/general/messageErreur';
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE, SORT_ICON,
} from '@/configuration/clientTableConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import childRowOrganisation from '@/components/clients/clients/organisation/childRowOrganisation';
import { TYPOLOGIE_GROUPE } from '@/configuration/tiers/tiersConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_ORGANISATION } from '@/configuration/general/referenceTableConf';
import formatDateIso from '@/services/general/formatIsoDate';
import { getSoldeMouvementStock } from '@/api/mouvementStock';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { createNamespacedHelpers } from 'vuex';
import { columnsSplice } from '@/services/general/columns';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { DEVIS as permClientsContacts } from '@/configuration/permissionsBodacConf';
import * as tiersConf from '@/configuration/tiers/tiersConf';
import generalTransformer from '@/services/general/filters/serverTableDataTransformer';
import PopUpTransferStock from '@/components/general/popUpTransferStock';
import tableFooterTotaux from '@/components/general/tableFooterTotaux';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    tiersInformation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      orderBy: null,
      ascending: null,
      liensInferieurs: null,
      transfertModale: false,
      groupe: TYPOLOGIE_GROUPE,
      resultPerPage: RESULTS_PER_PAGE,
      referenceTable: REFERENCE_TABLE_ORGANISATION,
    };
  },
  components: {
    PopUpTransferStock,
    routerLinkBlank,
    TableItemsInView,
    parametrageTable,
    exportExcelButton,
    tableFooterTotaux,
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    async closePopup() {
      this.transfertModale = false;
      await this.AddTiersEnfant(this.liensInferieurs);
    },
    async AddTiersEnfant(liens) {
      if (this.moduleStockActive) {
        const tiersIds = liens.tiersEnfants.map((tier) => tier.id);
        const soldeStock = (await getSoldeMouvementStock({
          tiersIds: tiersIds,
          dateSolde: formatDateIso(new Date()),
        })).data.result;
        liens.tiersEnfants.forEach(lien => {
          lien.soldeStock = soldeStock[lien.id] ?? 0;
        });
      }
      return liens;
    },
    onSorted({ column, ascending }) {
      this.orderBy = column;
      this.ascending = ascending;
    },
  },
  computed: {
    lastPayload() {
      return this.$store.getters['clients/lastPayload'];
    },
    permClientsContacts() {
      return permClientsContacts;
    },
    exportExcelQuery() {
      return {
        typeDonnee: tiersConf.EXPORT_EXCEL_CLIENT_ORGANISATIONS,
        typeExport: null,
        filtres: generalTransformer({
          orderBy: this.orderBy,
          ascending: this.ascending,
          query: {
            tierId: this.tiersInformation.id,
          },
        }),
      };
    },
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    moduleStockActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
    columns() {
      const columns = ['nomCommercial', 'adressePostale.adresse1', 'adressePostale.codePostal', 'adressePostale.ville', 'telephone', 'portable', 'email', 'soldeStock'];
      if (!this.moduleStockActive) {
        columnsSplice(columns, 'soldeStock');
      }
      return columns;
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          nomCommercial: this.$i18n.t('detailClient.organisation.tab.nom'),
          'adressePostale.adresse1': this.$i18n.t('detailClient.organisation.tab.adresse'),
          'adressePostale.codePostal': this.$i18n.t('detailClient.organisation.tab.codePostal'),
          'adressePostale.ville': this.$i18n.t('detailClient.organisation.tab.ville'),
          telephone: this.$i18n.t('detailClient.organisation.tab.telephone'),
          portable: this.$i18n.t('detailClient.organisation.tab.portable'),
          email: this.$i18n.t('detailClient.organisation.tab.email'),
          soldeStock: this.$i18n.t('detailClient.organisation.tab.soldeStock'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: texts,
        childRow: this.tiersInformation.typologie === TYPOLOGIE_GROUPE
          ? childRowOrganisation : null,
      };
    },
    targetTotal() {
      return ['soldeStock'];
    },
  },
  async mounted() {
    await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.moduleStockTiers.key]);
    const loadingComponent = this.$buefy.loading.open();
    try {
      const liens = (await getWithLiensInferieurs(this.tiersInformation.id)).data.result;
      this.liensInferieurs = await this.AddTiersEnfant(liens);
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.tiersInformation.nomCommercial }));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};

</script>
